import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import 'rc-tooltip/assets/bootstrap_white.css';
import './styles/main.scss';
import './posthog';
import Root from './root.component';
import CONSTANTS from 'shared/constants';
if (CONSTANTS.ENV != 'LOCAL') {
  {
    Sentry.init({
      dsn: SENTRY_DSN,
      release: VERSION,
      integrations: [Sentry.replayIntegration({
        maskAllText: false
      }), Sentry.browserTracingIntegration({
        tracingOrigins: ['marketing-dev.cinch.io'],
        // change to marketing.cinch.io when are ready for prod
        routingInstrumentation: Sentry.reactRouterV5BrowserTracingIntegration(React, window.location.pathname)
      })],
      ignoreErrors: ['Not Found', 'Request failed with status code 404'],
      // Session Replay
      // I've disabled these because they were costing overage fees and we haven't found them useful yet. -- Chris
      replaysSessionSampleRate: 0,
      // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 0,
      // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

      // Tracing
      // I've disabled these because they were costing overage fees and we haven't found them useful yet. -- Chris
      tracesSampleRate: 0,
      // only for dev, change to 0.1 in prod
      // turn on sampler when we want very specific sampling around certain API calls or routes, useful for new features on prod
      // tracesSampler: (samplingContext) => {
      //   // This function allows you to customize the sampling rate based on the context of the request.
      //   // For example, you can sample at a higher rate for specific routes or user actions.
      //   if (samplingContext.request.url.includes('/api/')) {
      //     return 0.5; // Sample at 50% for API requests
      //   }
      //   return 0.1; // Sample at 10% for other requests
      // },

      beforeSend: (event, hint) => {
        if (event?.extra?.__serialized__?.message === 'canceled') {
          // This is a weird unexplained error message.  I'm not sure what it means.
          // It might be bad to surpress it.  Let Chris know if you have any thoughts
          return null;
        }

        // Filter out request aborted errors - typically caused by user navigation
        const error = hint?.originalException;
        if (error?.code === 'ECONNABORTED' && error?.message === 'Request aborted') {
          // Don't send to Sentry - likely user navigating away from page
          return null;
        }
        if (error?.code === 'ERR_CANCELED') {
          // Request was cancelled via AbortController
          return null;
        }
        if (event.exception && window.CIErrorBoundary) {
          window.CIErrorBoundary(event);
        }
        return event;
      }
    });
  }
}
if (CONSTANTS.ENV != 'LOCAL') {
  (function (apiKey) {
    (function (p, e, n, d, o) {
      var v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
      for (w = 0, x = v.length; w < x; ++w) (function (m) {
        o[m] = o[m] || function () {
          o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
        };
      })(v[w]);
      y = e.createElement(n);
      y.async = !0;
      y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
  })(PENDO_API);
} else {
  // Mock Pendo for local development
  window.pendo = {
    initialize: () => {},
    updateOptions: () => {},
    isReady: () => false,
    host: null
  };
}

// may be unecessary
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/firebase-messaging-sw.js').then(function (registration) {
      // console.log('Firebase service worker registered:', registration);
      // You can now use Firebase messaging features.
    }).catch(function (error) {
      console.log('Error registering Firebase service worker:', error);
    });
  });
}

// React 18 mounts through a root rather than ReactDOM.render, which is gone in this
// version. Deliberately no StrictMode: it double-invokes effects in development, and this
// app has effects that aren't idempotent yet.
createRoot(document.querySelector('#app')).render(<Root />);